/**
 * Date labelling shared by the system prompt and the booking tools — pure, no
 * dependencies, so the Worker, the widget and the on-device driver all produce
 * identical labels. Names are hardcoded per language so the result never
 * depends on the runtime's Intl locale data (Dutch names are lowercase, as in
 * normal Dutch prose).
 */

export const WEEKDAY_NAMES = {
    en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    nl: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};

export const MONTH_NAMES = {
    en: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    nl: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};

/**
 * Label an ISO date (YYYY-MM-DD) in natural language — "maandag 6 juli" /
 * "Monday 6 July" — or null if missing/malformed. The input is ALREADY a
 * calendar date; reading the noon-UTC instant back in UTC always lands on that
 * same calendar date, so the weekday is exact, independent of any timezone.
 */
export function labelDate(date, locale) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(date ?? ''))) return null;

    const d = new Date(`${date}T12:00:00Z`);
    /* Round-trip check: JS rolls over out-of-range components ("2026-02-31" →
       March 3) instead of failing — reject anything that isn't a real date */
    if (Number.isNaN(d.getTime()) || d.toISOString().slice(0, 10) !== date) return null;

    const lang = locale === 'en' ? 'en' : 'nl';
    return `${WEEKDAY_NAMES[lang][d.getUTCDay()]} ${d.getUTCDate()} ${MONTH_NAMES[lang][d.getUTCMonth()]}`;
}
